module.exports = "<p>\r\n  sme works!\r\n</p>\r\n"